import { render, staticRenderFns } from "./DetailEditView.vue?vue&type=template&id=133c7ffa&scoped=true"
import script from "./DetailEditView.vue?vue&type=script&lang=js"
export * from "./DetailEditView.vue?vue&type=script&lang=js"
import style0 from "./DetailEditView.vue?vue&type=style&index=0&id=133c7ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c7ffa",
  null
  
)

export default component.exports